/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type { Goods, GoodsInterface } from "../../goods.sol/Goods";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "xxbToken",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "ProductAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "number",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalCost",
        type: "uint256",
      },
    ],
    name: "ProductBought",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "addProduce",
    outputs: [
      {
        internalType: "uint256",
        name: "productId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextProductId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "products",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint64",
        name: "stock",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "xxb",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GoodsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GoodsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Goods__factory extends ContractFactory {
  constructor(...args: GoodsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    xxbToken: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(xxbToken, overrides || {});
  }
  override deploy(
    xxbToken: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(xxbToken, overrides || {}) as Promise<
      Goods & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Goods__factory {
    return super.connect(runner) as Goods__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GoodsInterface {
    return new Interface(_abi) as GoodsInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Goods {
    return new Contract(address, _abi, runner) as unknown as Goods;
  }
}
